import { RootState } from '../../store';

export const getIsLoadingSelector = (state: RootState) => state?.documentReducer?.isLoading;
export const getFormErrorsSelector = (state: RootState) => state?.documentReducer?.formErrors;
export const getDocumentsSelector = (state: RootState) => state?.documentReducer?.documents;
export const getIdToDeleteSelector = (state: RootState) => state?.documentReducer?.idToDelete;
export const getErrorsSelector = (state: RootState) => state?.documentReducer?.errors;
export const getStatusSelector = (state: RootState) => state?.documentReducer?.status;
export const getDocumentSelector = (state: RootState) => state?.documentReducer?.document;
